var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardIcon',{attrs:{"icon":_vm.icon,"squareBackground":""}},[_c('HeadingMedium',[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.instructions)?_c('ParagraphBody',[_vm._v(" "+_vm._s(_vm.instructions)+" ")]):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }